export enum FeatureFlags {
    ENABLE_INTERNAL_BILLS_ADMIN = 'internal_enable_bills_product_reset',
    ENABLE_INTERNAL_SPROUT_DEV_TOOLS = 'internal_enable_ai_dev_tools',
    ENABLE_GOAL_ACCOUNT_LINKING = 'enable_goal_account_linking',
    ENABLE_BANKING_EXPERIENCE_TOGGLE = 'enable_banking_experience_toggle',
    ENABLE_PAYCHECK_ROUTING_CLEAR_BUTTON = 'enable_paycheck_routing_clear_button',
    ENABLE_CASH_CARD_NOTIFICATIONS = 'enable_cash_card_notifications',
    ENABLE_INCOME_SPLIT = 'enable_income_split',
    ENABLE_TIED_RULES = 'enable_tied_rules',
    ENABLE_POST_ACCOUNT_LINKING_SCREEN = 'enable_post_account_linking_screen',
    ENABLE_THROWERROR = 'enable_throwerror',
    ENABLE_IM_TAB = 'enable_im_tab',
    ENABLE_SPROUT_CHAT = 'enable_sprout_chat',
    ENABLE_INCOME_SPLIT_VISUALS = 'enable_income_split_visuals',
    ENABLE_TRANSACTION_SEARCH = 'enable_transaction_search',
    ENABLE_FREE_TO_SPEND_WIDGET = 'enable_free_to_spend_widget',
    ENABLE_FREE_TO_SPEND_TRANSACTIONS = 'enable_fts_transactions',
    ENABLE_APEX_ACCOUNT_PERFORMANCE = 'enable_apex_performance',
    ENABLE_MOBILE_CHECK_DEPOSIT = 'enable_mobile_check_deposit',
    ENABLE_GUIDANCE_SESSION_REMINDER_SMS = 'enable_guidance_session_reminder_sms',
    ENABLE_ARTIE_THE_ARTIFACT = 'enable_artie_the_artifact',
    ENABLE_CMM_EDITABLE_BILLS_WIDGET = 'enable_cmm_editable_bills_widget',
    ENABLE_MONEY_SYSTEM_TAB = 'enable_money_system_tab',
    ENABLE_CMM_EDITABLE_SAVINGS_GOALS_WIDGET = 'enable_cmm_editable_savings_goals_widget',
    ENABLE_MONEY_SYTEM_NEW_GOALS = 'enable_money_system_new_goals',
    ENABLE_BILLING_SETTINGS = 'enable_billing_settings',
    ENABLE_PREMIUM_MEMBERSHIPS = 'enable_premium_memberships',
    ENABLE_GOYO = 'enable_goyo',
}
